import { render, staticRenderFns } from "./SignupWizardStepVerifyEmail.vue?vue&type=template&id=71967f96&scoped=true&"
import script from "./SignupWizardStepVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./SignupWizardStepVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./SignupWizardStepVerifyEmail.vue?vue&type=style&index=0&id=71967f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71967f96",
  null
  
)

export default component.exports